import { render } from "./ModalPaymentAffiliate.vue?vue&type=template&id=f5546a7e&scoped=true"
import script from "./ModalPaymentAffiliate.vue?vue&type=script&lang=js"
export * from "./ModalPaymentAffiliate.vue?vue&type=script&lang=js"

import "./ModalPaymentAffiliate.vue?vue&type=style&index=0&id=f5546a7e&scoped=true&lang=css"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5546a7e"]])

export default __exports__